export interface VolunteerSettingsFormValue {
	enabled: boolean;
	volunteerTag: string;
}

export function toVolunteerSettingsPayload(
	value: VolunteerSettingsFormValue | undefined,
	featureEnabled: boolean
): { enabled: boolean; volunteerTag?: string } | undefined {
	if (!featureEnabled) {
		return undefined;
	}
	const tag = value?.volunteerTag?.trim();
	return { enabled: Boolean(value?.enabled), ...(tag ? { volunteerTag: tag } : {}) };
}
